<div class="row interest-filters" (clickOutside)="onClickedOutside($event)" (exclude)="'.single-selected'">
  <div class="col-md-12 col-sm-12">
    <div class="header">{{'discover.search_bar.interests' | translate}}</div>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="checkbox-filter">
      <achoo-filter-box #topicFilterBox [options]="discoverFilterBar.topics"
                        [(model)]="interestFilter.topicPercentage.value"
                        placeholder="{{'discover.search_bar.topic_placeholder' | translate}}"
                        multiple="true">
      </achoo-filter-box>
      <div class="slider-inner-container">
        <achoo-slider #topicRangeSlider [name]="'topicPercentageFilter'"
                      [min]="minValue" [max]="maxValue"
                      [from]="fromTopic"
                      [to]="toTopic"
                      [label]="'Share'"
                      [dataType]="'percent'"
                      [(model)]="interestFilter.topicPercentage.range"></achoo-slider>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 mt-20px mb-5px">
    <div class="checkbox-filter">
      <achoo-filter-box #industriesFilterBox [options]="discoverFilterBar.industries"
                        [(model)]="interestFilter.topIndustries.value"
                        placeholder="{{'discover.search_bar.industry_placeholder' | translate}}"
                        multiple="true">
      </achoo-filter-box>
      <div class="slider-inner-container">
        <achoo-slider #industrieseRangeSlider [name]="'topIndustriesFilter'"
                      [min]="minValue" [max]="maxValue"
                      [from]="fromIndustry"
                      [to]="toIndustry"
                      [label]="'Share'"
                      [dataType]="'percent'"
                      [(model)]="interestFilter.topIndustries.range"></achoo-slider>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="activity-filter-seperator"></div>
  </div>
  <div class="col-md-12 d-flex flex-row slider-container button-group">
    <button class="button gray" (click)="resetInterestFilters()">{{'common.btn.reset' | translate}}</button>
    <div class="d-flex flex-auto"></div>
    <button class="button blue" (click)="doSearchByInterestFilter()">{{'common.btn.save' | translate}}</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/discover/discover-search/interest-filter/interest-filter.component.html